import React from "react";
import { Link } from "react-router-dom";
import usePageTitle from "common/usePageTitle";
import "./MaturaCroatianEssayApplicationPage.css";

function MaturaCroatianEssayApplicationPage() {
  usePageTitle("Prijava mature - esej");

  return (
    <div className="essay-application-page">
      <section className="essay-application-form-section">
        <div className="essay-application-form-card">
          <div className="essay-application-form-head">
            <p className="essay-application-form-eyebrow">Online prijavnica</p>
            <h1>Prijava za pripreme iz hrvatskog eseja</h1>
          </div>

          <div className="essay-applications-closed">
            <p>Dragi učenici i roditelji,</p>
            <p>
              hvala vam na velikom interesu i povjerenju koje ste ukazali
              platformi lumen@home ❤️
            </p>
            <p>
              Obavještavamo vas da su prijave za online pripreme državne mature
              za školsku godinu 2025./2026. službeno zatvorene.
            </p>
            <p>
              Veselimo se radu sa svim prijavljenima, a ostalima – vidimo se
              iduće školske godine!
            </p>
            <p>Vaš lumen@home tim ✨</p>
          </div>

          <p className="essay-application-form-link">
            Više informacija o programu priprema nalazi se na{" "}
            <Link to="/pripreme-za-maturu">stranici priprema</Link>.
          </p>
        </div>
      </section>
    </div>
  );
}

export default MaturaCroatianEssayApplicationPage;
